<div class="stc-scroll" [style.max-height.px]="maxHeight">
  <table mat-table class="stc-table" [dataSource]="dataSource" [trackBy]="trackRow" matSort
         [matSortActive]="initialSort?.key ?? ''" [matSortDirection]="initialSort?.dir ?? ''" matSortDisableClear>
    @for (column of columnDefinitions; track column.key) {
      <ng-container [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
            [disabled]="!column.config.sortable"
            [start]="column.config.numeric ? 'desc' : 'asc'"
            [class.stc-num]="column.config.numeric"
            [class.stc-divider]="column.config.dividerAfter">
          {{ column.config.label | translate }}
        </th>

        <td mat-cell *matCellDef="let row"
            [class.stc-num]="column.config.numeric"
            [class.stc-divider]="column.config.dividerAfter">
          @if (cellTemplates.get(column.key); as tpl) {
            <ng-container *ngTemplateOutlet="tpl; context: { $implicit: row, column: column.key, isFooter: false }"></ng-container>
          } @else if (column.config.numeric) {
            {{ row[column.key] | number:'1.0-0' }}
          } @else {
            {{ row[column.key] | customFormat: column.config.format }}
          }
        </td>

        <td mat-footer-cell *matFooterCellDef
            [class.stc-num]="column.config.numeric"
            [class.stc-divider]="column.config.dividerAfter">
          @if (footer) {
            @if (cellTemplates.get(column.key); as tpl) {
              <ng-container *ngTemplateOutlet="tpl; context: { $implicit: footer, column: column.key, isFooter: true }"></ng-container>
            } @else if (column.config.numeric) {
              {{ footer[column.key] | number:'1.0-0' }}
            } @else {
              {{ footer[column.key] }}
            }
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columnKeys; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnKeys"></tr>
    @if (footer) {
      <tr mat-footer-row *matFooterRowDef="columnKeys; sticky: true"></tr>
    }

    <tr class="stc-empty-row" *matNoDataRow>
      <td [attr.colspan]="columnKeys.length">{{ emptyMessage | translate }}</td>
    </tr>
  </table>
</div>
